import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './ChilliPage.css';
import chilliLogo from '../images/chilli-logo.png';
import ranjithChilli from '../images/chilli-ranjith-img.png';
import ustad3322Chilli from '../images/chilli-ustad-3322-img.png';
import akira414 from '../images/chillli-akira-414-img.png';
import adhipathi279 from '../images/chilli-adhipathi279-img.png';
import anvika from '../images/chilli-anvika-img.png';
import aradhya21 from '../images/chilli-aradhya21-img.png';
import dynastyBullet from '../images/Chill-Dynasty-Bullet-img.png';
import hyena110 from '../images/chilli-hyena110-img.png';
import indra207 from '../images/chilli-indra207-img.png';
import keerthi531 from '../images/chilli-keerthi531-img.png';
import varshini22 from '../images/chilli-varshini22-img.png';
import vikranth7043 from '../images/chilli-vikranth-7043.png';
import winner2214 from '../images/chilli-winner2214-img.png';
import yodhaChilli from '../images/chilli-yodha-img.png';
import rolex819 from '../images/chilli-rolex819-img.png';
import sara9091 from "../images/chilli-sara-9091-img.png"
import legender45 from '../images/chilli-legender-45-img.png';
import adhipati279CarousalImg1 from '../images/adhipati279-carousal-img-1.jpeg';
import adhipati279CarousalImg2 from '../images/adhipati279-carousal-img-2.jpeg';
import adhipati279CarousalImg3 from '../images/adhipati279-carousal-img-3.jpeg';
import adhipati279CarousalImg4 from '../images/adhipati279-carousal-img-4.jpeg';
import adhipati279CarousalImg5 from '../images/adhipati279-carousal-img-5.jpeg';

const varieties = [
  {
    name: 'DYNASTY BULLET ',
    image: dynastyBullet,
    description: [
      'Category: Chilli hybrid',
      'Days to first picking: 50-55 days',
      'Plant habit: Spreading',
      'Fruit colour: Green',
      'Fruit length: 6-8 cm',
      'Fruit diameter: 1.4-1.6 cm',
      'Pungency: Highly pungent',
      'Disease tolerance: LCV',
      'Remark: Green fresh market and good shelf life',
    ],
  },
  {
    name: 'YODHA',
    image: yodhaChilli,
    description: [
      'YODHA Chilli is a high quality hot pepper variety with good tolerance against leaf curl virus',
      'High pungency and more fruit weight with less harvesting intervals (10-12 days)',
      'Type: Fresh medium long',
      'Maturity: 55-60 days after transplanting',
      'Fruit size: 8-10 cm length and 0.9-1.1 cm diameter',
      'Plant type: Semi spreading',
      'Fruit colour: Dark green',
      'Fruit type: Smooth, shiny and firm',
      'Early hybrid',
      'Suitable for long transportation',
    ],
  },
  {
    name: 'AKIRA - 414',
    image: akira414,
    description: [
      'Light green, slender and glossy fruits with thick skin suitable for transport',
      'Fruit size: 10-12 cm length and 1.2-1.4 cm width',
      'Early maturing variety with first harvest in 40-45 days',
      'Pungency: High',
      'Excellent for green chilli market consumption',
      'High yield potential with short picking interval',
      'Suitable for hot conditions and indoor or outdoor cultivation',
    ],
  },
  {
    name: 'ADHIPATHI -279',
    image: adhipathi279,
    carouselImages: [
      adhipati279CarousalImg1,
      adhipati279CarousalImg2,
      adhipati279CarousalImg3,
      adhipati279CarousalImg4,
      adhipati279CarousalImg5,
    ],
    description: [
      'Category: F1 Hybrid hot pepper (chilli)',
      'ADHIPATHI -279 is a farmer-friendly variety with a spreading growth habit for better space utilization.',
      'Fresh fruit color: Dark green',
      'Dry fruit color: Deep red with excellent color retention',
      'Fruit texture: Semi-wrinkled with attractive appearance and robust flavor',
      'Fruit length: 11-13 cm',
      'Fruit diameter: 1.3-1.4 cm',
      'Good virus tolerance to reduce crop loss and pesticide dependence',
      'Very high yielding potential',
      'Suitable for both market appeal and versatile end-use in dry chilli segment',
    ],
  },
  {
    name: 'ANVIKA',
    image: anvika,
    description: [
      'Semi erect hybrid suitable for dry chilli',
      'Fruit size 8-10cm long with width of 1.2-1.3cm',
      'Fruits are moderately pungent with good colour value',
      'Thin skinned deep red fruits on maturity',
      'Very high yielding hybrid',
    ],
  },
  {
    name: 'ARADHYA-21',
    image: aradhya21,
    description: [
      'Strong, erect plant type',
      'Fresh fruit color: Dark green',
      'Dry fruit color: Shiny red',
      'Fruit length: 8-9 cm',
      'Fruit breadth: 1-1.2 cm',
      'Maturity: Fresh green in 55-60 days after transplanting, red dry in 90-110 days',
      'Pungency: High',
      'F1 Hybrid chilli',
    ],
  },
  // {
  //   name: 'DYNASTY - 9041',
  //   image: dynasty9041,
  //   description: [
  //     'First choice of traders and marketers',
  //     'It produces semi erect and vigorous plants',
  //     'Earliness: Early',
  //     'Most suitable variety for green and red chilli',
  //     'Brilliant red dry chilli with high colour',
  //     'Scoville Heat Unit: 30000-40000 SHU',
  //     'ASTA colour value: 100 to 125',
  //     'Fruit size: 14 cm length and 1.2 cm diameter',
  //     'Dry fruit quality: Very good',
  //     'Fruit pungency: Medium',
  //     'High yielding variety',
  //   ],
  // },
  {
    name: 'SIRI-9091',
    image: sara9091,
    description: [
      'First choice of traders and marketers',
      'It produces semi erect and vigorous plants',
      'Most suitable variety for green and red chilli',
      'Brilliant red dry chilli with high colour',
      'Scoville Heat Unit: SARA-9091 dried red chilli ranges between 30000 SHU to 40000 SHU',
      'ASTA colour value: SARA-9091 dried red chilli ranges between 100 to 125',
      'It is a high yielding variety',
      'Plant Type: Semi erect and vigorous plant',
      'Earliness: Early',
      'Dry fruit quality: Very good',
      'Fruit Size: Length 14 cm, Diameter 1.2 cm',
      'Fruit Pungency: Medium',
    ],
  },
  {
    name: 'HYENA-1116',
    image: hyena110,
    description: [
      'Strong, erect plant type',
      'Fresh fruit color: Dark green',
      'Dry fruit color: Shiny red',
      'Fruit length: 8-9 cm',
      'Fruit breadth: 1-1.2 cm',
      'Maturity: Fresh green in 55-60 days after transplanting, red dry in 90-110 days',
      'Pungency: High',
      'F1 Hybrid chilli',
    ],
  },
  {
    name: 'INDRA-207',
    image: indra207,
    description: [
      'Tall, spreading and vigorous plant with dark green foliage',
      'Fruit size: 11-12 cm length and 1.2 cm diameter',
      'Fruit colour: Red on maturity',
      'Fruit weight: 7-8 gm with medium pungency',
      'Maturity: 70-75 days for fresh green and 90-95 days for red ripe fruits',
      'Red fruit harvesting starts in about 90-95 days from transplanting',
      'High yielding hybrid suitable for red dry and dual purpose use',
      'Good colour retention',
    ],
  },
  {
    name: 'KEERTHI-531',
    image: keerthi531,
    description: [
      'Semi erect bushy type of plants',
      'Fruits are light green, moderately wrinkled, shiny and attractive',
      'High yielding and fruits are medium pungent',
      'Fruits are about 12-14 cm long and about 1-1.2 cm in diameter',
      'Suitable for fresh market',
    ],
  },
  {
    name: 'VARSHIN-22',
    image: varshini22,
    description: [
      'Strong, erect plant type',
      'Fresh fruit color: Dark green',
      'Dry fruit color: Shiny red',
      'Fruit length: 7-8 cm',
      'Fruit breadth: 1-1.2 cm',
      'Maturity: Fresh green in 55-60 days after transplanting, red dry in 90-110 days',
      'Pungency: High',
      'F1 Hybrid chilli',
    ],
  },
  {
    name: 'VIKRANT-7043',
    image: vikranth7043,
    description: [
      'Semi erect bushy type hybrid',
      'Dark green fruits largely suitable for vegetable purpose',
      'Medium sized (8-10 cm long and 0.8-1.0 cm diameter) with slightly thick skin',
      'Highly pungent with medium number of seeds per fruit',
      'High yielder and suitable for long distance transport',
    ],
  },
  {
    name: 'WINNER-2214',
    image: winner2214,
    description: [
      'Strong, erect plant type',
      'Fresh fruit color: Dark green',
      'Dry fruit color: Shiny red',
      'Fruit length: 7-8 cm',
      'Fruit breadth: 1-1.2 cm',
      'Maturity: Fresh green in 55-60 days after transplanting, red dry in 90-110 days',
      'Pungency: High',
      'F1 Hybrid chilli',
    ],
  },
  {
    name: 'ROLEX-819',
    image: rolex819,
    description: [
      'F1 hybrid chilli perfect for both fresh consumption and drying',
      'Virus (LCV) and heat tolerant hybrid',
      'Plant habit: Spreading',
      'Fruit color: Light green',
      'Fruit length: 11-13 cm',
      'Fruit diameter: 1.3-1.5 cm',
      'Pungency: Medium',
      'First harvest: 50-55 days (green) and 95-100 days (red)',
    ],
  },
  {
    name: 'RANJITH',
    image: ranjithChilli,
    description: [
      'Highly pungent and attractive dual-purpose chilli hybrid',
      'Easy to pick and harvest',
      'Uniform fruits of 9-10 cm length and 0.8-1.0 cm diameter',
      'Immature fruit colour: Dark green',
      'Mature fruit colour: Red',
      'Fruit surface has moderate wrinkles',
    ],
  },
  {
    name: 'USTAD-3322 ',
    image: ustad3322Chilli,
    description: [
      'Plant type: Strong and erect',
      'Fruit colour (fresh): Dark green',
      'Fruit colour (dry): Shiny red',
      'Fruit dimensions: 8-9 cm length and 1-1.2 cm breadth',
      'Maturity: 55-60 DAT for green fruits and 90-110 DAT for red dry fruits',
      'Pungency: High',
    ],
  },
  {
    name: 'LEGENDER-45',
    image: legender45,
    description: [
      'Category: F1 Hybrid chilli',
      'A highly pungent F1 hybrid chilli variety with attractive parrot-green, smooth, and shiny fruits',
      'Fruit Appearance: Typically 12–16 cm long and 1.2–1.4 cm wide, featuring vibrant parrot-green color and smooth texture',
      'Pungency: Highly pungent, popular choice for spice-focused markets',
      'Maturity: Early-maturing hybrid with first harvest 45 to 55 days after transplanting (DAT)',
      'Heat Tolerance: Excellent heat-set performer, maintains fruit production even in high temperatures',
      'High-yielding hybrid with quick turnaround',
      'Developed by Dynasty Agriseeds',
    ],
  },
  

  
 
];

export default function ChilliPage() {
  return <ProductPatternPage title="Chilli" varieties={varieties} pageClass="chilli-page" heroImage={chilliLogo} />;
}
